export const OneStarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 74 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.5 19L38.1839 24.1824H43.6329L39.2245 27.3853L40.9084 32.5676L36.5 29.3647L32.0916 32.5676L33.7755 27.3853L29.3671 24.1824H34.8161L36.5 19Z"
        fill="currentColor"
      />
    </svg>
  );
};
